import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { logger } from '@/utils/logger'
import '@/styles/index.css'

// Initialize logger (enables window.getLogConfig() and window.setLogLevel())
const log = logger.module('Main');

// Global error handler
window.addEventListener('error', (event) => {
  log.error('Global error caught:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  log.error('Unhandled promise rejection:', event.reason);
});

// Initialize Sentry only if DSN is properly configured
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn && sentryDsn.startsWith('https://') && !sentryDsn.includes('your-sentry-dsn')) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE || 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: import.meta.env.MODE !== 'development', // Disable in dev
  });
} else {
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  log.error('Root element not found!');
  throw new Error('Root element not found');
}


ReactDOM.createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
)

